<template lang="pug">
  #footer.container-fluid
    .footer_con
      .footer_logo
        img(src="@/assets/img/tap_logo.png")
      .footer_font
        .font_left
          .left_li
            router-link.font_li(v-for="(item,index) in navList_left" :to="item.path" :key="index") {{item.name}}
          .left_li
            router-link.font_li(v-for="(item,index) in navList_right" :to="item.path" :key="index") {{item.name}}
        .font_middle
          p 邮箱：ciweianquan@ciwei.com
          p 地址：湖南省长沙市岳麓区麓谷企业广场E1栋1单元
          p 联系电话：17570769541 蒋女士
        .font_right
          .font_right_li 
            img(src="@/assets/img/bottom_wxgzh.png")
            p 微信公众号
          .font_right_li 
            img(src="@/assets/img/bottom_wxqy_n.png")
            p 官方客服
      p.copy 
        | 湖南刺猬安全科技有限公司
        span 版权所有
        span |
        a(href="https://beian.miit.gov.cn/" target="_blank") 湘ICP备19002762号-1
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      navList_left: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "信息预警",
          path: "/informationwarning",
          children: []
        },
        {
          name: "海外安全",
          path: "/overseassecurity",
          children: []
        }
      ],
      navList_right: [
        {
          name: "商贸服务",
          path: "/investmentcommerce",
          children: []
        },
        {
          name: "海外社群",
          path: "/overseascommunities",
          children: []
        },
        {
          name: "关于我们",
          path: "/aboutus",
          children: []
        }
      ]
    }
  }
};
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  color: #fff;
  height: 292px;
  background: #1A2D4D;
  overflow: hidden;
  text-align: center;
  .footer_con {
    width: 1170px;
    margin: auto;
    .footer_logo {
      height: 60px;
      margin-top: 34px;
      border-bottom: 1px solid #466084;
      img {
        width: 170px;
      }
    }
    .footer_font {
      width: 100%;
      height: 145px;
      border-bottom: 1px solid #466084;
      .font_left {
        float: left;
        width: 170px;
        height: 100%;
        font-weight: 400;
        .left_li {
          float: left;
          width: 65px;
          margin-top: 20px;
          .font_li {
            display: block;
            width: 65px;
            color: #ffffff;
            font-size: 16px;
            line-height: 35px;
            text-align: left;
            &:hover {
              text-decoration: none;
            }
          }
          &:nth-child(2) {
            margin-left: 40px;
          }
        }
      }
      .font_middle {
        float: left;
        width: 425px;
        margin-top: 27px;
        margin-left: 165px;
        text-align: left;
      }
      .font_right {
        display: flex;
        justify-content: space-between;
        float: right;
        width: 190px;
        margin-top: 22px;
        .font_right_li {
          width: 83px;
          img {
            width: 100%;
          }
          p {
            margin-top: 5px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #ffffff;
  font-size: 14px;
  margin: 15px 0 10px;
  font-weight: 400;
  span, a {
    margin-left: 20px;
  }
  a {
    color: #fff;
    text-decoration: none;
  }
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue